import { Link } from "react-router-dom";
import { ArrowRight, MessageCircleQuestion } from "lucide-react";
import { Reveal } from "./Reveal";
import { AmbientOrbs } from "./Ambient";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export const FAQ = () => (
  <section id="faq" className="relative overflow-hidden bg-white py-16 md:py-20" data-testid="faq-section">
    <AmbientOrbs />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] lg:gap-16">
        <div>
          <Reveal>
            <span className="inline-flex items-center rounded-full border border-emerald2-300/40 bg-emerald2-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-emerald2-600">
              FAQ
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-navy-900 md:text-4xl lg:text-5xl">
              Frequently asked questions
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 max-w-md text-base text-slate-600 md:text-lg">
              Can't find what you're looking for? Talk to our team directly for a straight answer.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/contact"
              data-testid="faq-contact"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-navy-900 px-6 py-3.5 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(15,30,60,0.2)] transition-transform duration-300 hover:scale-105"
            >
              <MessageCircleQuestion className="h-4 w-4 text-gold-400" />
              Ask a Question
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
            </Link>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="divide-y divide-navy-900/10" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`} className="border-b border-navy-900/10 py-2" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-base font-semibold text-navy-900 hover:no-underline md:text-lg">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-600 md:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
